import { Component, OnInit, inject } from '@angular/core';
import {Activiteit, ActiviteitType, VerwerkingsStatus} from '../../../activiteit/activiteit';
import {Observable, ReplaySubject, Subject} from 'rxjs';
import {ZoneService} from '../../../zone/zone.service';
import {Zone} from '../../../zone/zone';
import {ActiviteitService} from '../../../activiteit/activiteit.service';
import {SortOrder} from '../../../core/sort/sort-order';
import {ActiviteitPageRequest} from '../../../activiteit/activiteit-page-request';
import {map, mergeMap, tap} from 'rxjs/operators';
import {ActiviteitPage} from '../../../activiteit/activiteit-page';
import {Router} from '@angular/router';
import {Dienst} from '../../../dienst/dienst';
import {DienstService} from '../../../dienst/dienst.service';

@Component({
    templateUrl: './activiteiten.page.html',
    styleUrls: ['./activiteiten.page.scss'],
    standalone: false
})
export class ActiviteitenPage implements OnInit {
  private activiteitService = inject(ActiviteitService);
  private zoneService = inject(ZoneService);
  private dienstService = inject(DienstService);
  private router = inject(Router);

  initialPageRequest: ActiviteitPageRequest = ActiviteitPageRequest.firstActiviteitenPageRequest(VerwerkingsStatus.OPEN, SortOrder.ASCENDING, 10);
  activiteitenPage$: Subject<ActiviteitPage> = new ReplaySubject<ActiviteitPage>(1);
  zones$: Observable<Array<Zone>>;
  diensten$: Observable<Array<Dienst>>;
  private currentPageRequest: ActiviteitPageRequest;

  ngOnInit(): void {
    this.getActiviteiten$(this.initialPageRequest).subscribe();
    this.zones$ = this.zoneService.getZones$();
    this.diensten$ = this.dienstService.getDiensten$().pipe(map(data => data.getDiensten()));
  }

  onVerwerkClicked(activiteit: Activiteit): void {
    this.activiteitService.verwerkActiviteit$(activiteit.getId())
      .pipe(mergeMap(() => this.getActiviteiten$(this.currentPageRequest.toFirstPage())))
      .subscribe();
  }

  onPageChange(pageRequest: ActiviteitPageRequest): void {
    this.getActiviteiten$(pageRequest).subscribe();
  }

  private getActiviteiten$(pageRequest: ActiviteitPageRequest): Observable<ActiviteitPage> {
    this.currentPageRequest = pageRequest;
    return this.activiteitService
      .getActiviteiten$(this.currentPageRequest)
      .pipe(tap(page => this.activiteitenPage$.next(page)));
  }

  onActiviteitClicked(activiteit: Activiteit): void {
    if (activiteit.getType() === ActiviteitType.CLIENT_MELDING) {
      this.router.navigateByUrl(`/clienten/${activiteit.getClientId()}/meldingen`);
    } else if (activiteit.getType() === ActiviteitType.SIGNAALKAART) {
      this.router.navigateByUrl(`clienten/${activiteit.getClientId()}/signaalkaarten/${activiteit.getId()}`);
    }
  }
}
